import { render, staticRenderFns } from "./IndepenPwa.vue?vue&type=template&id=206ab68e&scoped=true"
import script from "./IndepenPwa.vue?vue&type=script&lang=js"
export * from "./IndepenPwa.vue?vue&type=script&lang=js"
import style0 from "./IndepenPwa.vue?vue&type=style&index=0&id=206ab68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ab68e",
  null
  
)

export default component.exports